const L = {
  name: "Integration",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.05 15.5859L8.04996 12.5858L6.63574 14L12.05 19.4142L17.4642 14L16.05 12.5858L13.05 15.5857V0H11.05V15.5859Z" fill="currentColor"/>
<path d="M16.0501 4.58578L22.1872 10.7229C23.3945 11.9302 23.4016 13.8949 22.1854 15.099L22.1829 15.1014L14.2372 23.0471C13.0301 24.2542 11.0658 24.2615 9.86163 23.0457L9.85869 23.0428L1.90301 15.1071C0.695681 13.8998 0.688631 11.935 1.905 10.7309L8.04012 4.59579L9.45433 6.01L3.31722 12.1471L3.31287 12.1514C2.89173 12.5674 2.88534 13.2606 3.31687 13.6925L11.2816 21.6372C11.6977 22.0585 12.3911 22.0648 12.823 21.6329L20.7773 13.6786C21.1986 13.2624 21.2049 12.569 20.773 12.1371L14.6359 6L16.0501 4.58578Z" fill="currentColor"/>
</svg>
  `
};
export {
  L as Integration
};
